const updateEquipments = {
  name: 'EQUIPAMENTO',
  conditionTrue: 'REATIVADO',
  conditionFalse: 'INATIVADO',
  newMaintenanceStatus: 'MANUTENÇÃO',
  newMaintenanceStatusTrue: 'ENVIADO PARA A',
  newMaintenanceStatusFalse: 'RETORNO DA'
};

export default updateEquipments;
